import { Dispatch, Fragment, useContext, useEffect, useState } from 'react';
import { Col } from 'react-bootstrap';
import Select from 'react-select';
import PlusIcon from '../../../../../assets/images/svg/plus-button-icon.svg';
import { ProductListingContext } from '../../../functions/data_formatting_functions';
import {
  actionSetAllAttributes,
  actionSetListingData,
} from '../../../store/create_listing_actions';
import ShowImage from '../../../../../components/show_image';
import { getAttributesNames } from '../../../functions/get_options_dropdown_format';
import { CardStyled, Label } from '../../../../../styles/style';
import AddPhotosModal from '../../media/modals/add_photos_modal';
import { StoreDetails } from '../../../../../data/types/stores';
import { S3ApiRepository } from '../../../../../data/repositories/s3_repository';
import { ApiRepository } from '../../../../../data/repositories/base_repository';
import { ImageType } from '../../../../../data/types/files';
import delete_image from '../../../../../assets/images/svg/delete-icon.svg';
import { AttributeType } from '../../../../../data/types/attributes';
import { ListingState } from '../../../../../data/types/listings';
import { formatAttributeValues } from '../../../../../utils/functions/formatting_functions';
import { defaultPlaceholderEmptyImage_path } from '../../../../../assets/index';
import { Colors, Fonts } from '../../../../../config/theme';
import imgloading from '../../../../../assets/images/svg/image-loading-icon.svg';
import { IoClose } from 'react-icons/io5';
import { FaCheck } from 'react-icons/fa6';

type AttributeImageSelectionProps = {
  currentStore?: StoreDetails;
  actionGetStoreImages?: (payload: any) => { type: string; payload: any };
  s3Repository: S3ApiRepository;
  filesRepository: ApiRepository;
};

export default function AttributeImageSelection({
  currentStore,
  actionGetStoreImages,
  s3Repository,
  filesRepository,
}: AttributeImageSelectionProps) {
  const {
    state,
    dispatch,
  }: {
    state: ListingState;
    dispatch: Dispatch<any>;
  } = useContext(ProductListingContext);
  const [sideBar, SetSideBar] = useState(false);
  const [attr_value, SetSelectedAttributeValue] = useState<string>();
  const [selectedAttribute, setselectedAttribute] = useState<any>();
  const [selectedAttributeName, setselectedAttributeName] = useState<any>();
  const [selected_index, setselectedIndex] = useState<any>();

  const [options, setOptions] = useState<
    {
      label: string;
      value: string;
    }[]
  >([]);

  useEffect(() => {
    setOptions(
      getAttributesNames(
        state.all_attributes.filter(
          (attr: any) => attr.type === AttributeType.SELECT,
        ),
      ),
    );

    if (selectedAttribute) {
      if (
        state.all_attributes?.filter(
          (attr: any) => attr.name_en === selectedAttribute,
        ).length === 0
      ) {
        setselectedAttribute(undefined);
        setselectedAttributeName(undefined);
        setselectedIndex(undefined);
      }
    }
  }, [state, state.all_attributes, selectedAttribute]);

  const chooseImage = (attr: any, index: number) => {
    if (index != null) {
      setselectedIndex(index);
    } else {
      return;
    }
    SetSideBar(true);
    SetSelectedAttributeValue(attr);
  };

  const get_image = (imageId: number) => {
    return state.data?.imagesList?.filter(
      (img: ImageType) => img?.id === imageId,
    )[0];
  };

  const getImagesOfAttributeValues = () => {
    const matchedAttr = state.all_attributes?.filter(
      (attr) => attr?.name_en === selectedAttribute,
    )[0];

    return matchedAttr?.values_en?.map(
      (attr_name_en: string, index: number) => {
        return (
          <div
            key={index}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              margin: '25px 0px',
            }}
          >
            <div>
              {formatAttributeValues(
                attr_name_en,
                matchedAttr!.values_ar![index],
                AttributeType.SELECT,
              )}
            </div>
            <div>
              <input
                type="file"
                id={`selectImage${index}`}
                style={{ display: 'none' }}
              />
              {matchedAttr.values_en &&
              state?.data?.selectedImages &&
              state?.data?.selectedImages[matchedAttr.name_en] &&
              state?.data?.selectedImages[matchedAttr.name_en][attr_name_en] &&
              state?.data?.selectedImages[matchedAttr.name_en][attr_name_en] ? (
                <div style={{ position: 'relative' }}>
                  {/* Delete Image */}
                  <img
                    className="del-button"
                    src={delete_image}
                    alt="remove_image"
                    style={{
                      position: 'absolute',
                      top: -5,
                      right: -5,
                      cursor: 'pointer',
                      zIndex: 0, // Ensure the delete image appears above the other content
                    }}
                    width="18px"
                    height="18px"
                    onClick={() => {
                      if (matchedAttr.values_en) {
                        delete state?.data?.selectedImages[matchedAttr.name_en][
                          attr_name_en
                        ];
                        state?.data?.select_attrs?.map((attr) => {
                          if (attr.name_en === matchedAttr.name_en) {
                            attr.values_images![index] = '';
                          }
                        });

                        dispatch(actionSetListingData({ ...state.data }));
                      }
                    }}
                  />

                  {/* Original Image */}
                  <div
                    style={{
                      height: '60px',
                      width: '60px',
                      cursor: 'pointer',
                    }}
                    onClick={() => chooseImage(attr_name_en, index)}
                  >
                    <ShowImage
                      image={get_image(
                        state?.data?.selectedImages[matchedAttr.name_en][
                          attr_name_en
                        ],
                      )}
                      style={{
                        borderRadius: '5px',
                        height: '60px',
                        width: '60px',
                        objectFit: 'scale-down',
                      }}
                    />
                  </div>
                </div>
              ) : (
                <img
                  src={PlusIcon}
                  alt={'add-attribute-image'}
                  style={{ cursor: 'pointer' }}
                  onClick={() => chooseImage(attr_name_en, index)}
                />
              )}
            </div>
          </div>
        );
      },
    );
  };

  const addImagesToAttribute = (image: ImageType) => {
    let isBroken = false;

    state.all_attributes.map((attr, index: number) => {
      if (isBroken) {
        if (index === state.all_attributes?.length - 1) isBroken = false;
        return;
      }
      isBroken = updateValuesImages(attr, image);
    });

    dispatch(
      actionSetListingData({
        ...state.data,
        numeric_attrs: state.all_attributes?.filter(
          (attr: any) => attr.type === AttributeType.NUMERIC,
        ),
        select_attrs: state.all_attributes?.filter(
          (attr: any) => attr.type === AttributeType.SELECT,
        ),
        boolean_attrs: state.all_attributes?.filter(
          (attr: any) => attr.type === AttributeType.BOOLEAN,
        ),
      }),
    );
    dispatch(actionSetAllAttributes([...state.all_attributes]));
    SetSideBar(false);
  };
  const handleCancel = () => {
    SetSideBar(false);
  };

  const updateValuesImages = (attr: any, image: ImageType) => {
    if (
      (attr.values_en &&
        attr?.values_en.includes(attr_value) &&
        attr.name_en === selectedAttribute) ||
      (attr.values &&
        attr?.values.includes(attr_value) &&
        attr.name_en === selectedAttribute)
    ) {
      if (selected_index !== null) {
        attr.values_images![selected_index] = image.id;
        if (attr.values_en) {
          state.data.selectedImages[attr.name_en][
            attr.values_en[selected_index]
          ] = image.id;
        } else {
          state.data.selectedImages[attr.name_en][attr.values[selected_index]] =
            image.id;
        }
        dispatch(
          actionSetListingData({
            ...state.data,
            selectedImages: {
              ...state.data.selectedImages,
              [attr.name_en]: {
                ...state.data.selectedImages[attr.name_en],
                [attr.values_en[selected_index]]: image.id,
              },
            },
          }),
        );
        setselectedIndex(null);
        return true;
      }
    }
    return false;
  };

  const renderAttributesImages = () => {
    const seenAttrs = new Set();
    return (
      <>
        <hr />

        <div className="between" style={{ margin: '10px 0px' }}>
          <Label color="#00273380">
            {' '}
            Currently selected attribute photos:{' '}
          </Label>
        </div>
        {state.all_attributes
          .filter((attr: any) => attr.type === AttributeType.SELECT)
          .map((attr: any, index: number) => {
            if (
              seenAttrs.has(attr.id) ||
              !state?.data?.selectedImages ||
              !state?.data?.selectedImages[attr.name_en]
            )
              return;
            seenAttrs.add(attr.id);
            const numberOfImages = Object.keys(
              state?.data?.selectedImages[attr.name_en],
            ).length;
            return (
              <Fragment key={index}>
                {numberOfImages > 0 && (
                  <div // <Icon
                    style={{
                      textAlign: 'left',
                      margin: '0px 0px 20px 0px',
                    }}
                  >
                    <span className="attr_name_dark float-start">
                      {attr.name_en}
                      {attr.values_en.length !== numberOfImages && (
                        <span style={{ color: 'red' }}>
                          {' '}
                          (missing {attr.values_en.length - numberOfImages})
                        </span>
                      )}
                    </span>
                    <br />
                    <div // <Icon
                      style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(5, 1fr)',
                        justifyContent: 'flex-start',
                        margin: '10px 10px 10px 10px',
                      }}
                    >
                      {attr.values_en?.map((_: any, index: number) => {
                        return (
                          <Fragment key={index}>
                            {state?.data?.selectedImages[attr.name_en][
                              attr.values_en[index]
                            ] ? (
                              <div // <Icon
                                style={{
                                  height: '50px',
                                  width: '50px',
                                  margin: '5px',
                                }}
                              >
                                <ShowImage
                                  image={get_image(
                                    state?.data?.selectedImages[attr.name_en][
                                      attr.values_en[index]
                                    ],
                                  )}
                                  onClick={() =>
                                    chooseImage(attr.values_en[index], index)
                                  }
                                  style={{
                                    height: '50px',
                                    width: '50px',
                                    minWidth: '50px',
                                    borderRadius: '5px',
                                  }}
                                />
                              </div>
                            ) : (
                              <div // <Icon
                                style={{
                                  height: '50px',
                                  width: '50px',
                                  margin: '5px',
                                }}
                              >
                                <img
                                  src={defaultPlaceholderEmptyImage_path}
                                  alt={'add-attribute-image'}
                                  style={{
                                    borderRadius: '5px',
                                    height: '50px',
                                    width: '50px',
                                  }}
                                />
                              </div>
                            )}
                          </Fragment>
                        );
                      })}
                    </div>
                  </div>
                )}
              </Fragment>
            );
          })}
      </>
    );
  };

  return state.productType !== 1 ? (
    <></>
  ) : (
    <CardStyled>
      <div className="head">
        <h1 className="d-flex">Choose images for attribute values</h1>
      </div>
      <div className="d-flex p-1">
        {selectedAttribute ? (
          <div>
            <p
              style={{
                fontFamily: Fonts.secondary,
                color: Colors.secondaryText,
              }}
            >
              <span style={{ color: Colors.greenMain }}> Note: </span> Attribute
              images must be of the same style (theme).
            </p>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-around',
                alignItems: 'center',
                height: '60px',
                border: `1px solid ${Colors.greenSecondary} `,
                borderRadius: '5px',
              }}
            >
              <ShowImage
                imageSrc={
                  'https://development-image-store-silal.s3.eu-central-1.amazonaws.com/s3_images/uploaded_objects/silal/1208.jpeg?versionId=anKftKxpS6qCMuq6phBlddQD8jP3ftmk'
                }
                style={{
                  width: '50px',
                  height: '50px',
                  objectFit: 'scale-down',
                }}
              />
              <ShowImage
                imageSrc={
                  'https://development-image-store-silal.s3.eu-central-1.amazonaws.com/s3_images/uploaded_objects/silal/1212.jpeg?versionId=HeE2dOIqSxx3.3nGGOiApqkOAXouIspF'
                }
                style={{
                  width: '50px',
                  height: '50px',
                  objectFit: 'scale-down',
                }}
              />{' '}
              <ShowImage
                imageSrc={
                  'https://development-image-store-silal.s3.eu-central-1.amazonaws.com/s3_images/uploaded_objects/silal/1213.jpeg?versionId=QUI7NSrP9fa2v4UeK2koJvg.uUQNhnmP'
                }
                style={{
                  width: '50px',
                  height: '50px',
                  objectFit: 'scale-down',
                }}
              />
              <ShowImage
                imageSrc={
                  'https://development-image-store-silal.s3.eu-central-1.amazonaws.com/s3_images/uploaded_objects/silal/1215.jpeg?versionId=5QGp2utGMLGumZ5lq5pkgCC7O39Fna3e'
                }
                style={{
                  width: '50px',
                  height: '50px',
                  objectFit: 'scale-down',
                }}
              />{' '}
              <IoClose size={20} color="red" />
            </div>
            <div
              style={{
                marginTop: '10px',
                display: 'flex',
                justifyContent: 'space-around',
                alignItems: 'center',
                height: '60px',
                border: `1px solid ${Colors.greenSecondary} `,
                borderRadius: '5px',
              }}
            >
              <ShowImage
                imageSrc={
                  'https://development-image-store-silal.s3.eu-central-1.amazonaws.com/s3_images/uploaded_objects/silal/1210.jpeg?versionId=vZw8LOiowNlYV.i32zlGYfnvg1mfrUlv'
                }
                style={{
                  width: '50px',
                  height: '50px',
                  objectFit: 'scale-down',
                }}
              />
              <ShowImage
                imageSrc={
                  'https://development-image-store-silal.s3.eu-central-1.amazonaws.com/s3_images/uploaded_objects/silal/1212.jpeg?versionId=HeE2dOIqSxx3.3nGGOiApqkOAXouIspF'
                }
                style={{
                  width: '50px',
                  height: '50px',
                  objectFit: 'scale-down',
                }}
              />{' '}
              <ShowImage
                imageSrc={
                  'https://development-image-store-silal.s3.eu-central-1.amazonaws.com/s3_images/uploaded_objects/silal/1214.jpeg?versionId=7_hSeTxRUESamWYSOJTrp_Rpn8D7X2pi'
                }
                style={{
                  width: '50px',
                  height: '50px',
                  objectFit: 'scale-down',
                }}
              />
              <ShowImage
                imageSrc={
                  'https://development-image-store-silal.s3.eu-central-1.amazonaws.com/s3_images/uploaded_objects/silal/1215.jpeg?versionId=5QGp2utGMLGumZ5lq5pkgCC7O39Fna3e'
                }
                style={{
                  width: '50px',
                  height: '50px',
                  objectFit: 'scale-down',
                }}
              />{' '}
              <FaCheck size={20} color={Colors.greenMain} />
            </div>
            <br />
          </div>
        ) : (
          <div>
            <p
              style={{
                fontFamily: Fonts.secondary,
                color: Colors.secondaryText,
              }}
            >
              <span
                style={{
                  color: Colors.greenMain,
                  fontWeight: 'bold',
                }}
              >
                What is this?
              </span>{' '}
              Attribute images are images that represent the value of the
              attribute, they can be set for Text Attributes only.{' '}
              <span
                style={{
                  color: Colors.greenMain,
                }}
              >
                Example:
              </span>{' '}
            </p>
            <ShowImage
              imageSrc={
                'https://development-image-store-silal.s3.eu-central-1.amazonaws.com/s3_images/uploaded_objects/silal/1209.jpeg?versionId=ybSdtox68Kj1M_mn1MUlSCB6sdJH0_pU'
              }
              style={{
                width: '100%',
                height: '400px',
                objectFit: 'scale-down',
              }}
            />
          </div>
        )}
      </div>
      <div className="between">
        <Label color="#00273380"> Attribute to add photos for: </Label>
      </div>
      <div // <Icon
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Select
          isClearable
          options={options}
          className="react-select"
          placeholder={'Attribute Name'}
          onChange={(val) => {
            console.log(val);
            if (val === null) {
              setselectedAttribute(undefined);
              setselectedAttributeName(undefined);
              return;
            }
            setselectedAttribute(val.value!);
            setselectedAttributeName(selectedAttribute?.name);
          }}
          value={selectedAttributeName}
        />
      </div>
      {selectedAttribute && (
        <div // <Icon
          style={{
            textAlign: 'center',
            marginTop: '10px',
          }}
        >
          <Label color="#00273380">
            Current "{selectedAttribute}" images are:
          </Label>

          {getImagesOfAttributeValues()}
        </div>
      )}
      {renderAttributesImages()}

      <AddPhotosModal
        actionGetStoreImages={actionGetStoreImages}
        currentStore={currentStore}
        isModalVisible={sideBar}
        handleCancel={handleCancel}
        setPhotoBarModal={SetSideBar}
        selection={true}
        addImagesToAttribute={addImagesToAttribute}
        s3Repository={s3Repository}
        filesRepository={filesRepository}
        addOrSelectActionsOnly={false}
      />
    </CardStyled>
  );
}
